import { MyProductsViewToggle } from "./components/my-products-view-toggle";
import { useMyProductsViewStore } from "./store/useMyProductsViewStore";
import { useDashboardFilters } from "../../store/useDashboardFilters";
import { DashboardChartProductUsage } from "../dashboard-chart-product-usage";
import { DashboardChartProductCompetency } from "../dashboard-chart-product-competency";
import { DashboardSection } from "../dashboard-ds";
import { useTranslation } from "react-i18next";

/**
 * Meus produtos (Figma 6038:3389): toggle Crédito/Moeda à direita do título,
 * visão financeira em tiles e evolução de uso por produto.
 */
export function DashboardMyProductsView() {
  const { viewMode, setViewMode } = useMyProductsViewStore();
  const filters = useDashboardFilters((s) => s.filters);
  const [translate] = useTranslation(["dashboard"]);

  return (
    <DashboardSection
      title={translate("dashboard-my-products-view-title")}
      data-testid="dashboard-my-products"
      action={
        <MyProductsViewToggle
          className="w-full md:w-60 md:shrink-0"
          mode={viewMode}
          onChange={setViewMode}
        />
      }
    >
      <div className="flex flex-col gap-5">
        <DashboardChartProductUsage
          startDate={filters.startDate}
          endDate={filters.endDate}
          city={filters.cities ?? undefined}
          group_id={filters.group_id ?? undefined}
          type={filters.type ?? undefined}
          status={filters.status ?? undefined}
          users={filters.users ?? undefined}
          spaces={filters.spaces ?? undefined}
          viewMode={viewMode}
        />
        <DashboardChartProductCompetency
          startDate={filters.startDate}
          endDate={filters.endDate}
          city={filters.cities ?? undefined}
          group_id={filters.group_id ?? undefined}
          type={filters.type ?? undefined}
          status={filters.status ?? undefined}
          users={filters.users ?? undefined}
          spaces={filters.spaces ?? undefined}
          viewMode={viewMode}
        />
      </div>
    </DashboardSection>
  );
}
